<template>
<div class="pageWrapper">

	<header v-bind:class="{'navbar-fixed-top': $route.isPage && xsflg}" id="pageHeader" class="pageHeader">
		<div v-bind:class="{'navbar-fixed-top': !$route.isPage && xsflg}" class="pageHeader__row1 container">
			<div class="pageHeader__inner row">
				<my-nav v-bind:wwidth="wWidth"></my-nav>
			</div>
		</div>

		<template v-if="!$route.isPage">
		<div class="searchBlock2">
			<my-imagesearch></my-imagesearch>
		</div>
		</template>


		<div v-bind:class="{'isPage': $route.isPage, 'collapse': $route.isPage && xsflg}" id="searchBlock" class="pageHeader__row2 searchBlock">
			<my-searchwords v-bind:xsflg="xsflg"></my-searchwords>
			<my-advancedsearch v-if="$route.isPage" v-bind:xsflg="xsflg" v-bind:collapse="true"></my-advancedsearch>
		</div>

	</header>
	<!--/pageHeader-->

	<div class="pageContent container">
		<div class="pageContent__inner row">
			<div class="pageContent__primary col-xs-12 col-sm-9 col-md-9">
				<router-view></router-view>
			</div>

			<div class="pageContent__secondary col-xs-12 col-sm-3 col-md-3">
				<my-sidebar v-bind:xsflg="xsflg"></my-sidebar>
			</div>
		</div>
	</div>
	<!--/pageContent-->

	<div class="topBtn">
		<a v-on:click.prevent="smoothScroll('body')">
			<img src="static/images/btn/pagetop_pc.png" alt="ページトップへ戻る">
		</a>
	</div>

	<my-topicpath v-if="isDetail($route.path)"></my-topicpath>

	<footer class="pageFooter">
		<div class="pageFooter__inner container">
			<my-footer></my-footer>
		</div>
	</footer>
	<!--/pageFooter-->

	<debug-console></debug-console>
</div>
</template>

<script>
import store from './src/vuex/store';
module.exports = {
	store: store,
	data: function(){
		return {
			wWidth: '',
			xsflg: false,
			icons: {
				ck_rhorizont_white: {icon: 'icon_rhorizont_white', title: 'アールホリゾント'},
				ck_natural_light: {icon: 'icon_natural_light', title: '自然光'},
				ck_floor: {icon: 'icon_floor', title: '木床・タイル床'},
				ck_down_shot: {icon: 'icon_down_shot', title: '俯瞰撮影'},
				ck_vtr: {icon: 'icon_vtr', title: 'ムービー・VTR'},
				ck_synchronous_recording: {icon: 'icon_synchronous_recording', title: '同時録音'},
				ck_communication_environment: {icon: 'icon_communication_environment', title: 'LAN対応'},
				ck_kitchen: {icon: 'icon_kitchen', title: 'キッチン'},
				ck_makeup_room: {icon: 'icon_makeup_room', title: 'メイクルーム'},
				ck_direct_carrying: {icon: 'icon_direct_carrying', title: '車直接搬入'},
				ck_shower_room: {icon: 'icon_shower_room', title: 'シャワールーム'},
				ck_stock_room: {icon: 'icon_stock_room', title: 'ストックルーム・倉庫'},
				ck_flash_rental: {icon: 'icon_flash_rental', title: 'ストロボレンタル'},
				ck_hmi_rental: {icon: 'icon_hmi_rental', title: 'HMIレンタル'},
				ck_machine_rental: {icon: 'icon_machine_rental', title: '機材レンタル'},
				ck_assistant_service: {icon: 'icon_assistant_service', title: 'アシスタント'},
				ck_eu_style_belong: {icon: 'icon_eu_style_belong', title: '洋風'},
				ck_jp_style_belong: {icon: 'icon_jp_style_belong', title: '和風'},
				ck_multi_space: {icon: 'icon_multi_space', title: '多目的スペース'},
				ck_bathroom: {icon: 'icon_bathroom', title: 'バスルーム'},
				ck_terrace: {icon: 'icon_terrace', title: 'テラス'},
				ck_jp_garden: {icon: 'icon_garden', title: '庭（和風）'},
				ck_eu_garden: {icon: 'icon_garden', title: '庭（洋風）'},
				ck_furniture: {icon: 'icon_furniture', title: '家具レンタル'}
			},
			scStr: ''
		};
	},
	created: function(){
		this.$on('deliverFavAction', function(args){
			// console.log(args);
			this.$broadcast('receiveFavAction', args);
		});

		this.$on('deliverRefreshFavorites', function(args){
			this.$broadcast('receiveRefreshFavorites', args);
		});

		this.$on('putScStr', function(args){
			// console.log(args);
			this.$set('scStr', args);
		});

		// ブロードキャスト
		this.$on('leaveDetail', function(){
			// console.log('leaveDetail');
			this.$broadcast('resLeaveDetail');
		});

		this.$on('topicpath', function(obj){
			this.$broadcast('resTopicpath', obj);
		});
	},
	ready: function(){
		// console.log('app ready');

		// resize
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
	},
	beforeDestroy: function () {
		window.removeEventListener('resize', this.handleResize);
		window.removeEventListener('load', this.handleResize);
	},
	methods: {
		handleResize: function(){
			var breakpoint = 768;
			this.wWidth = window.innerWidth;
			// console.log(this.wWidth);
			if (window.innerWidth < breakpoint){
				if (!this.xsflg){
					this.xsflg = true;
					this.addFixedHeaderPosition();
					// console.log(this.xsflg);
				}
			} else {
				if (this.xsflg){
					this.xsflg = false;
					this.removeFixedHeaderPosition();
					this.removeStyle(document.getElementById('searchBlock'));
					// console.log(this.xsflg);
				}
			}
		},
		addFixedHeaderPosition: function(){
			var wrapper = document.getElementsByClassName('pageWrapper');
			var header = document.getElementsByClassName('pageHeader__row1');
			var headerHeight = header[0].clientHeight;
			wrapper[0].style.paddingTop = headerHeight + 'px';
		},
		removeFixedHeaderPosition: function(){
			var wrapper = document.getElementsByClassName('pageWrapper');
			wrapper[0].style.paddingTop = '';
		},
		removeStyle: function(target){
			target.setAttribute('style', '');
		},
		isDetail: function(path){
			return path.match(/^\/detail\//);
		}
	},
	events: {
		// 'hook:created': function () {
		// 	console.log('created!');
		// },
		// 'hook:attached': function () {
		// 	console.log('attached!');
		// },
		// 'hook:ready': function () {
		// 	console.log('ready!');
		// },
		// 'hook:detached': function () {
		// 	console.log('detached!');
		// },
		// 'hook:beforeDestroy': function () {
		// 	console.log('beforeDestroy!');
		// }
	},
	components: {
		'debug-console': require('./src/components/debug_console.vue')
	},
	mixins: [
		require('./src/mixins/smoothScroll.js')
	]
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// app.vue?2a495eaa